import * as React from "react";
const SvgFiRrFlaskPotion = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-flask-potion_svg__a)">
      <path
        fill="#062147"
        d="M17.549 6.595a.99.99 0 0 1-.55-.885V2h1a1 1 0 1 0 0-2H6a1 1 0 1 0 0 2h1v3.665c0 .376-.221.698-.554.887C-.5 10.5-.001 16.503 0 16.554c0 .053.128 2.11.385 3.048C1.095 22.192 3.475 24 6.176 24h11.646c2.7 0 5.08-1.809 5.79-4.398.257-.938.387-1.909.387-2.888 0-4.221-2.471-8.099-6.45-10.119M7.339 8.341A2.98 2.98 0 0 0 9 5.665V2h6v3.71c0 1.13.63 2.152 1.644 2.668 2.26 1.147 3.934 3.004 4.767 5.17-.894.503-2.853 1.452-4.91 1.452-1.651 0-2.864-.455-4.147-.937C10.958 13.54 9.516 13 7.5 13c-1.921 0-3.866.809-5.234 1.542.653-2.629 2.474-4.901 5.073-6.201m14.345 10.733c-.471 1.723-2.06 2.926-3.86 2.926H6.177c-1.802 0-3.39-1.203-3.86-2.926a9 9 0 0 1-.311-2.051C2.942 16.409 5.326 15 7.5 15c1.652 0 2.865.455 4.148.937C13.044 16.46 14.486 17 16.5 17c2.196 0 4.223-.836 5.42-1.454q.08.578.08 1.168c0 .8-.107 1.594-.317 2.36"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-flask-potion_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFlaskPotion;
